/* R&B gallery (rb-gallery: FW26 S11 + S14), shop the look (rb-look: idea 01 + S13 look slides, merged 7 Oct) and
   product feature (rb-spotlight: Add to bag only).
   Arrows, swipe, a tap on a side picture or a small picture; no autoplay. "See the pieces" opens the drawer
   (desktop: from the right, phones: a sheet from below). Add / Add the look put the pieces in the bag and open it.
   Loaded once (guard), works for sections added in the theme editor. */
(function () {
  if (window.RbGallery) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function root() { var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; return r.charAt(r.length - 1) === '/' ? r : r + '/'; }
  function track(action, sec) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'rb_look', rb_look_action: action, rb_look_section: sec.getAttribute('data-rbg') }); } catch (e) {}
  }
  // swap content calmly: fade out, change, fade in (at once with reduced motion)
  function swap(els, fn, now) {
    if (now || reduce.matches || !els.length) { fn(); return; }
    els.forEach(function (e) { e.classList.add('is-out'); });
    setTimeout(function () { fn(); els.forEach(function (e) { e.classList.remove('is-out'); }); }, 180);
  }

  function init(sec) {
    if (!sec || sec.rbg) return;
    var slides = [].slice.call(sec.querySelectorAll('[data-rbg-slide]'));
    var L = slides.length; // 0 in the product feature, which only uses the bag part
    sec.rbg = true;
    var cur = 0;
    var title = sec.querySelector('[data-rbg-title]');
    var nums = [].slice.call(sec.querySelectorAll('[data-rbg-num], [data-rbg-drnum]'));
    var thumb = sec.querySelector('[data-rbg-thumb]');
    var belows = [].slice.call(sec.querySelectorAll('[data-rbg-below]'));
    var dr = sec.querySelector('[data-rbg-dr]');
    var veil = sec.querySelector('.rbg-veil');
    var panels = dr ? [].slice.call(dr.querySelectorAll('[data-rbg-panel]')) : [];
    var drTitle = sec.querySelector('[data-rbg-drtitle]');
    var gos = [].slice.call(sec.querySelectorAll('[data-rbg-go]'));
    var fades = [].slice.call(sec.querySelectorAll('[data-rbg-fade]'));
    if (title && fades.indexOf(title) < 0) fades.push(title);

    function pos(i) {
      var d = i - cur;
      if (L > 2) { if (d > L / 2) d -= L; if (d < -L / 2) d += L; }
      return d === 0 ? 'is-0' : d === -1 ? 'is-m1' : d === 1 ? 'is-p1' : d < 0 ? 'is-m2' : 'is-p2';
    }
    function show(n, now) {
      if (!L) return;
      var next = ((n % L) + L) % L;
      if (next === cur && !now) return;
      cur = next;
      slides.forEach(function (s, i) {
        s.classList.remove('is-0', 'is-m1', 'is-p1', 'is-m2', 'is-p2');
        s.classList.add(pos(i));
        var on = i === cur;
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.querySelectorAll('button, a').forEach(function (b) { b.tabIndex = on ? 0 : -1; });
      });
      var label = pad(cur + 1) + ' / ' + pad(L);
      nums.forEach(function (e) { e.textContent = label; });
      if (thumb) { thumb.style.width = (100 / L) + '%'; thumb.style.left = (cur * 100 / L) + '%'; }
      gos.forEach(function (g) { if (+g.getAttribute('data-rbg-go') === cur) g.setAttribute('aria-current', 'true'); else g.removeAttribute('aria-current'); });
      var t = slides[cur].getAttribute('data-rbg-t') || '';
      swap(fades, function () {
        if (title) title.textContent = t;
        belows.forEach(function (b) { b.hidden = +b.getAttribute('data-rbg-below') !== cur; });
      }, now);
      if (drTitle) drTitle.textContent = t;
      panels.forEach(function (p) { p.hidden = +p.getAttribute('data-rbg-panel') !== cur; });
    }

    // drawer
    var lastFocus = null;
    // the carousel option (S12) has no slides: its "+" buttons say which picture's pieces to open
    var cards = [].slice.call(sec.querySelectorAll('[data-rbg-card]'));
    function setPanel(i) {
      var src = slides[i] || cards[i];
      if (drTitle && src) drTitle.textContent = src.getAttribute('data-rbg-t') || '';
      if (!L) { var N = cards.length; sec.querySelectorAll('[data-rbg-drnum]').forEach(function (e) { e.textContent = pad(i + 1) + ' / ' + pad(N); }); }
      panels.forEach(function (p) { p.hidden = +p.getAttribute('data-rbg-panel') !== i; });
      return panels.filter(function (p) { return !p.hidden; })[0];
    }
    function open(i) {
      var panel = setPanel(i === undefined || isNaN(i) ? cur : i);
      if (!dr || !panel || !panel.querySelector('[data-rbg-row]')) return;
      lastFocus = document.activeElement;
      dr.removeAttribute('inert');
      dr.classList.add('is-open'); if (veil) veil.classList.add('is-open');
      document.documentElement.classList.add('rbg-lock');
      var x = dr.querySelector('.rbg-dr__x'); if (x) setTimeout(function () { x.focus({ preventScroll: true }); }, 50);
      track('open', sec);
    }
    function close(keepFocus) {
      if (!dr || !dr.classList.contains('is-open')) return;
      dr.classList.remove('is-open'); if (veil) veil.classList.remove('is-open');
      dr.setAttribute('inert', '');
      document.documentElement.classList.remove('rbg-lock');
      if (!keepFocus && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    sec.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-rbg-prev]')) { show(cur - 1); return; }
      if (t.closest('[data-rbg-next]')) { show(cur + 1); return; }
      var g = t.closest('[data-rbg-go]'); if (g) { show(+g.getAttribute('data-rbg-go')); return; }
      var o = t.closest('[data-rbg-open]'); if (o) { e.preventDefault(); open(o.hasAttribute('data-rbg-i') ? +o.getAttribute('data-rbg-i') : undefined); return; }
      var cp = t.closest('[data-rbg-cprev], [data-rbg-cnext]'); if (cp) { carStep(cp.hasAttribute('data-rbg-cnext') ? 1 : -1); return; }
      if (t.closest('[data-rbg-close]')) { close(); return; }
      var sz = t.closest('.rbg-sz__b');
      // sold-out size in a drawer (Carl 11 Oct): Notify me instead of choosing it
      if (sz && sz.hasAttribute('data-so')) { if (sec.rblSo) sec.rblSo(sz); return; }
      if (sz && !sz.disabled) {
        var grp = sz.parentNode, row = sz.closest('[data-rbg-row]');
        grp.querySelectorAll('.rbg-sz__b').forEach(function (b) { b.setAttribute('aria-checked', b === sz ? 'true' : 'false'); });
        var f = row && row.querySelector('[data-rbg-size]'); if (f) f.value = sz.getAttribute('data-v');
        if (row) {
          // Carl 19 Oct: "1 left" is no longer inside the box (it pushed the size up); it shows under the sizes when chosen
          var fw = sz.classList.contains('is-few') && sz.querySelector('small');
          var sw = T.sizew.charAt(0).toUpperCase() + T.sizew.slice(1);
          msg(row.querySelector('[data-rbg-msg]'), fw ? sw + ' ' + sz.getAttribute('data-l') + ' · ' + fw.textContent.trim() : '', !!fw);
          row.classList.remove('is-warn');
        }
        return;
      }
      var add = t.closest('[data-rbg-add]'); if (add) { addRow(add.closest('[data-rbg-row]'), add); return; }
      var all = t.closest('[data-rbg-all]'); if (all) { addAll(all.closest('.rbg-panel'), all); return; }
      var s = t.closest('[data-rbg-slide]');
      if (s && !t.closest('a')) {
        var i = +s.getAttribute('data-rbg-slide');
        if (i !== cur) show(i);
        else if (sec.rblLook && s.hasAttribute('data-rbg-has')) sec.rblLook(cur);
        else if (s.hasAttribute('data-rbg-has') || s.querySelector('[data-rbg-open]')) open();
      }
    });
    sec.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (dr && dr.contains(e.target)) return;
      if (e.target.closest('select, input')) return;
      if (e.key === 'ArrowLeft') { show(cur - 1); } else if (e.key === 'ArrowRight') { show(cur + 1); }
    });

    // Swipe (Carl 7 Oct: smooth on phones and with a Mac trackpad or Magic Mouse). The pictures follow the finger
    // while it moves (no transition), and on release glide on with the same .34s ease, or back if the move was short.
    // Vertical page scrolling stays native (touch-action: pan-y).
    var stage = sec.querySelector('[data-rbg-stage]');
    if (stage && L > 1) {
      var single = sec.classList.contains('rbg--single');
      var x0 = null, y0 = 0, t0 = 0, dx = 0, axis = '', moved = false, pid = null;
      // phones show the next picture peeking in (Carl 11 Oct), so the picture follows the finger 1:1 there
      function setDx(v) { dx = v; stage.style.setProperty('--dx', (single && window.innerWidth >= 990 ? v * 0.35 : v) + 'px'); }
      function release(go) {
        stage.classList.remove('is-drag');
        setDx(0);
        if (go) show(cur + go);
      }
      stage.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.target.closest('button, .rbk-hs')) return;
        x0 = e.clientX; y0 = e.clientY; t0 = e.timeStamp; axis = ''; moved = false; pid = e.pointerId;
      });
      stage.addEventListener('pointermove', function (e) {
        if (x0 === null || e.pointerId !== pid) return;
        var mx = e.clientX - x0, my = e.clientY - y0;
        if (!axis) {
          if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
          axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
          if (axis === 'y') { x0 = null; return; }
          moved = true; stage.classList.add('is-drag');
          try { stage.setPointerCapture(pid); } catch (err) {}
        }
        if (reduce.matches) return;
        var w = stage.clientWidth || 1;
        setDx(Math.max(-w, Math.min(w, mx)));
      });
      function end(e) {
        if (x0 === null) return;
        var mx = e.clientX - x0, v = Math.abs(mx) / Math.max(1, e.timeStamp - t0); x0 = null;
        if (axis !== 'x') { release(0); return; }
        // a short quick flick counts as well as a long slow drag
        var w = stage.clientWidth || 1;
        release(Math.abs(mx) > Math.min(90, w * 0.18) || (Math.abs(mx) > 24 && v > 0.45) ? (mx < 0 ? 1 : -1) : 0);
      }
      stage.addEventListener('pointerup', end);
      stage.addEventListener('pointercancel', function () { x0 = null; release(0); });
      stage.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      stage.addEventListener('dragstart', function (e) { e.preventDefault(); });

      // Trackpad / Magic Mouse: a sideways two-finger swipe follows the same way. One swipe = one picture; the
      // trackpad's momentum after it is ignored, so a swipe never skips two pictures.
      var wx = 0, wIdle = null, wLock = 0;
      stage.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) || e.ctrlKey) return; // vertical scroll and pinch stay native
        e.preventDefault();
        if (e.timeStamp < wLock) return;
        var px = e.deltaMode === 1 ? e.deltaX * 16 : e.deltaX;
        wx -= px;
        var w = stage.clientWidth || 1;
        stage.classList.add('is-drag');
        if (!reduce.matches) setDx(Math.max(-w * .4, Math.min(w * .4, wx)));
        clearTimeout(wIdle);
        if (Math.abs(wx) > Math.min(110, w * .14)) {
          var go = wx < 0 ? 1 : -1; wx = 0; wLock = e.timeStamp + 650;
          release(go);
          return;
        }
        wIdle = setTimeout(function () { wx = 0; release(0); }, 160);
      }, { passive: false });
    }

    // add to bag
    var T = { select: sec.getAttribute('data-t-select'), adding: sec.getAttribute('data-t-adding'), added: sec.getAttribute('data-t-added'), err: sec.getAttribute('data-t-err'), sizew: sec.getAttribute('data-t-sizew') || 'size' };
    function msg(el, text, ok) { if (!el) return; el.textContent = text || ''; el.classList.toggle('is-ok', !!ok); }
    function pick(row) {
      var f = row.querySelector('[data-rbg-size]');
      var m = row.querySelector('[data-rbg-msg]');
      if (!f) return null;
      if (!f.value) {
        msg(m, T.select);
        var first = row.querySelector('.rbg-sz__b:not([disabled]):not([data-so])'); if (first) try { first.focus(); } catch (e) {}
        row.classList.remove('is-warn'); void row.offsetWidth; row.classList.add('is-warn');
        return null;
      }
      msg(m, '');
      var on = row.querySelector('.rbg-sz__b[aria-checked="true"]');
      return { id: Number(f.value), quantity: 1, size: on ? on.getAttribute('data-l') : '' };
    }
    // As on the product page (Carl 7 Oct): no grey and no "Adding…"; "✓ Added · size 50" slides in on the tap, and
    // the bag opens at once with its thin loading line until the new line is in.
    var TICK = '<svg width="13" height="10" viewBox="0 0 13 10" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M1 5l4 4 7-8"/></svg>';
    function doneOn(btn, size) {
      var d = btn.querySelector('.rbg-add__d'); if (!d) return;
      d.innerHTML = TICK + '<span>' + T.added + (size ? ' · ' + T.sizew + ' ' + size : '') + '</span>';
      btn.classList.remove('is-done'); void btn.offsetWidth; btn.classList.add('is-done');
      clearTimeout(btn.rbT); btn.rbT = setTimeout(function () { btn.classList.remove('is-done'); }, 2600);
    }
    function doneOff(btn) { clearTimeout(btn.rbT); btn.classList.remove('is-done'); }
    // stay (whole look v4, Carl 20 Oct): the drawer stays open and the bag only counts up; ok runs after the add
    function post(items, btn, size, fail, stay, ok) {
      var drawer = document.querySelector('cart-drawer');
      var sections = drawer && typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
      btn.setAttribute('aria-busy', 'true');
      doneOn(btn, size);
      var opened = false;
      if (!stay) setTimeout(function () {
        close(true);
        if (drawer && !drawer.classList.contains('is-empty') && typeof drawer.open === 'function') { drawer.classList.add('rb-adding'); drawer.open(); opened = true; }
      }, 260);
      var url = ((window.routes && window.routes.cart_add_url) || root() + 'cart/add') + '.js';
      fetch(url, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items.map(function (i) { return { id: i.id, quantity: 1 }; }), sections: sections, sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          var d = res.d || {};
          if (!res.ok || d.status) throw new Error(d.description || d.message || T.err);
          btn.removeAttribute('aria-busy');
          if (drawer) drawer.classList.remove('rb-adding');
          if (stay) {
            if (drawer && d.sections && typeof drawer.renderContents === 'function') { if (!d.key && d.items && d.items[0]) d.key = d.items[0].key; drawer.renderContents(d); }
            if (ok) ok();
          } else if (drawer && d.sections && typeof drawer.renderContents === 'function') {
            close(true);
            drawer._shouldAutoOpen = true;
            if (!d.key && d.items && d.items[0]) d.key = d.items[0].key; // "Just added" on the new line
            drawer.renderContents(d);
          } else { window.location.href = (window.routes && window.routes.cart_url) || root() + 'cart'; return; }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rb-gallery', cartData: d });
        })
        .catch(function (err) {
          // Shopify's own messages (e.g. not enough in stock) are shown; a dropped connection gets ours
          btn.removeAttribute('aria-busy'); doneOff(btn);
          if (drawer) { drawer.classList.remove('rb-adding'); if (opened && typeof drawer.close === 'function') drawer.close(); }
          fail(err && err.message && !(err instanceof TypeError) ? err.message : T.err);
        });
    }
    function addRow(row, btn) {
      if (!row || btn.getAttribute('aria-busy') === 'true') return;
      var it = pick(row); if (!it) return;
      var m = row.querySelector('[data-rbg-msg]');
      post([it], btn, it.size, function (err) { msg(m, err); if (dr && !dr.classList.contains('is-open') && row.closest('[data-rbg-dr]')) open(); });
      track('add', sec);
    }
    function addAll(panel, btn) {
      if (!panel || btn.getAttribute('aria-busy') === 'true') return;
      var items = [], missing = false;
      [].slice.call(panel.querySelectorAll('[data-rbg-row]')).forEach(function (row) {
        if (!row.querySelector('[data-rbg-size]')) return; // sold out
        var it = pick(row); if (it) items.push(it); else missing = true;
      });
      var m = panel.querySelector('[data-rbg-allmsg]');
      if (missing || !items.length) { msg(m, T.select); return; }
      msg(m, '');
      post(items, btn, '', function (err) { msg(m, err); if (dr && !dr.classList.contains('is-open') && panel.closest('[data-rbg-dr]')) open(); });
      track('add_look', sec);
    }

    // Shop the look v2 (Carl 9 Oct): one line per piece with "Select size"; the sizes open in one drawer (desktop,
    // 600 px like the bag) / sheet (phones). "Select size" shows that piece, "Add the look" every piece of the look,
    // and the button counts what gets added ("Add 1 piece · 20,000 SEK"). After adding: "✓ Added · size 50 · Change".
    if (sec.hasAttribute('data-rbl') && dr) {
      var pcs = [].slice.call(dr.querySelectorAll('[data-rbl-pc]'));
      var go = dr.querySelector('[data-rbl-go]'), goL = dr.querySelector('[data-rbl-gol]'), dMsg = dr.querySelector('[data-rbl-msg]');
      var dKick = dr.querySelector('[data-rbl-kick]'), dT = dr.querySelector('[data-rbl-t]');
      var kick0 = ((sec.querySelector('.rbl-top > .rbk-kick') || {}).textContent || '').trim();
      var LT = { bag: sec.getAttribute('data-t-bag'), n1: sec.getAttribute('data-t-n1'), nn: sec.getAttribute('data-t-nn'), look: sec.getAttribute('data-t-look'), pick: sec.getAttribute('data-t-pick'), picks: sec.getAttribute('data-t-picks') };
      var mode = 'one', lk = 0, lkey = '';
      // the section carries 1,000,000 in the market's own format; its separator and currency are reused for totals
      var ms = (sec.getAttribute('data-rbl-money') || '').trim(), mm = ms.match(/1(\D?)000\1(?:000)/);
      var money = function (c) {
        var t = String(Math.round(c / 100));
        if (!mm) return t;
        return ms.replace(mm[0], t.replace(/\B(?=(\d{3})+(?!\d))/g, mm[1]));
      };
      var shown = function () { return pcs.filter(function (p) { return !p.hidden && !p.hasAttribute('data-rbl-so'); }); };
      // a piece can come in more colours (Carl 9 Oct): the colour shown is the one that counts
      var cvOf = function (p) { return p.querySelector('.rbl-cv:not([hidden])') || p; };
      var chosen = function (p) { var f = cvOf(p).querySelector('[data-rbg-size]'); return f && f.value ? f : null; };
      var sizeOf = function (p) { var on = cvOf(p).querySelector('.rbg-sz__b[aria-checked="true"]'); return on ? on.getAttribute('data-l') : ''; };
      var colOf = function (p) { var c = cvOf(p); return c.getAttribute('data-rbl-cv') !== p.getAttribute('data-rbl-p0') ? (c.getAttribute('data-rbl-col') || '').trim() : ''; };
      var swapCol = function (p, id) {
        var was = sizeOf(p);
        p.querySelectorAll('[data-rbl-cvt]').forEach(function (e) { e.hidden = e.getAttribute('data-rbl-cvt') !== id; });
        p.querySelectorAll('[data-rbl-cv]').forEach(function (e) { e.hidden = e.getAttribute('data-rbl-cv') !== id; });
        p.querySelectorAll('[data-rbl-pics]').forEach(function (e) { e.hidden = e.getAttribute('data-rbl-pics') !== id; });
        var nm = '';
        p.querySelectorAll('[data-rbl-to]').forEach(function (b) { var on = b.getAttribute('data-rbl-to') === id; b.setAttribute('aria-pressed', on ? 'true' : 'false'); if (on) nm = b.getAttribute('data-n') || ''; });
        if (typeof pLab === 'function') setTimeout(function () { pLab(p); }, 0);
        var n = p.querySelector('[data-rbl-swn]'); if (n) n.textContent = nm;
        // keep the size if the new colour has it
        if (was && !chosen(p)) {
          var same = [].slice.call(cvOf(p).querySelectorAll('.rbg-sz__b:not([disabled]):not([data-so])')).filter(function (b) { return b.getAttribute('data-l') === was; })[0];
          if (same) same.click();
        }
        foot();
      };
      var foot = function () {
        var list = shown(), txt;
        if (mode === 'one') {
          var p = list[0], z = p && chosen(p) ? sizeOf(p) : '';
          txt = z ? LT.bag + ' · ' + T.sizew + ' ' + z : (LT.pick || LT.bag);
          go.classList.toggle('is-off', !(p && chosen(p)));
        } else {
          var sel = list.filter(chosen), sum = 0;
          sel.forEach(function (p) { sum += +cvOf(p).getAttribute('data-c') || 0; });
          if (!sel.length) txt = LT.picks || LT.look;
          else if (sel.length === list.length) txt = LT.look + ' · ' + money(sum);
          else txt = (sel.length === 1 ? LT.n1 : LT.nn.replace('{n}', sel.length)) + ' · ' + money(sum);
          go.classList.toggle('is-off', !sel.length);
        }
        goL.textContent = txt;
      };
      var openL = function (m, k, key) {
        mode = m; lk = k; lkey = key || '';
        pcs.forEach(function (p) {
          p.classList.remove('is-sz');
          p.querySelectorAll('[data-rbl-psz]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
          var id = p.getAttribute('data-rbl-pc');
          p.hidden = m === 'one' ? id !== key : id.split(':')[0] !== String(k);
          p.querySelectorAll('[data-rbg-msg]').forEach(function (m) { msg(m, ''); });
          p.querySelectorAll('.is-warn').forEach(function (r) { r.classList.remove('is-warn'); });
          p.querySelectorAll('[data-rbl-bis]').forEach(function (b) { b.hidden = true; b.innerHTML = ''; });
          p.querySelectorAll('.rbg-sz__b[data-so][aria-checked="true"]').forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
          var pics = p.querySelector('.rbl-pics:not([hidden])'); if (pics) pics.scrollLeft = 0;
        });
        dr.classList.toggle('rbl-dr--look', m === 'look');
        dr.classList.remove('is-bis');
        if (m === 'look') {
          var num = L > 1 ? pad(k + 1) + ' / ' + pad(L) : '';
          dKick.textContent = kick0 + (num ? (kick0 ? ' · ' : '') + num : '');
          dKick.hidden = !dKick.textContent;
          var src = slides[k] || cards[k];
          dT.textContent = (src && src.getAttribute('data-rbg-t')) || (title && title.textContent) || LT.look;
        } else { dKick.hidden = true; dT.textContent = LT.pick; }
        msg(dMsg, '');
        foot();
        lastFocus = document.activeElement;
        dr.removeAttribute('inert');
        dr.classList.add('is-open'); if (veil) veil.classList.add('is-open');
        document.documentElement.classList.add('rbg-lock');
        var body = dr.querySelector('.rbg-dr__body'); if (body) body.scrollTop = 0;
        var x = dr.querySelector('.rbg-dr__x'); if (x) setTimeout(function () { x.focus({ preventScroll: true }); }, 50);
        track(m === 'look' ? 'open_look' : 'open_size', sec);
      };
      sec.rblLook = function (k) { openL('look', k); };
      // whole look v4: the piece's own Add to bag says the size and price once a size is picked
      var pLab = function (p) {
        var b = p.querySelector('.rbl-cv:not([hidden]) [data-rbl-padd]') || p.querySelector('[data-rbl-padd]'); if (!b) return;
        var l = b.querySelector('[data-rbl-pl]'), z = chosen(p) ? sizeOf(p) : '', c = +cvOf(p).getAttribute('data-c') || 0;
        if (l) l.textContent = z ? LT.bag + ' · ' + T.sizew + ' ' + z + ' · ' + money(c) : (LT.pick || LT.bag);
        p.querySelectorAll('[data-rbl-padd]').forEach(function (x) { x.classList.toggle('is-off', !z); });
      };

      // Back in stock in the drawer (Carl 11 Oct): a sold-out size can be tapped; under that piece: the line, the
      // email field and Notify me. Sign-ups go to Klaviyo's back-in-stock like the product page (assets/rb-pdp.js).
      var bisKey = sec.getAttribute('data-rbl-bis');
      var lang = (document.documentElement.lang || '').slice(0, 2);
      var BT = lang === 'sv' ? { t: 'Storlek {size} är slutsåld. Vi mejlar dig när den är tillbaka.', email: 'E-postadress', go: 'Meddela mig', done: 'Vi mejlar dig när storlek {size} är tillbaka.', errEmail: 'Ange en giltig e-postadress.', errSend: 'Något gick fel. Försök igen.' }
        : lang === 'de' ? { t: 'Größe {size} ist ausverkauft. Wir benachrichtigen Sie per E-Mail, sobald sie wieder verfügbar ist.', email: 'E-Mail-Adresse', go: 'Benachrichtigen', done: 'Wir benachrichtigen Sie per E-Mail, sobald Größe {size} wieder verfügbar ist.', errEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.', errSend: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.' }
        : { t: 'Size {size} is sold out. We will email you when it is back.', email: 'Email address', go: 'Notify me', done: 'We will email you when size {size} is back.', errEmail: 'Enter a valid email address.', errSend: 'Something went wrong. Please try again.' };
      var esc = function (x) { return String(x).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
      var savedEmail = function () { try { return localStorage.getItem('rb_bis_email') || ''; } catch (e) { return ''; } };
      sec.rblSo = function (b) {
        if (!dr.contains(b)) return;
        var cv = b.closest('[data-rbg-row]'); if (!cv) return;
        var box = cv.querySelector('[data-rbl-bis]'); if (!box) return;
        var on = b.getAttribute('aria-checked') === 'true';
        cv.querySelectorAll('.rbg-sz__b').forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
        var f = cv.querySelector('[data-rbg-size]'); if (f) f.value = '';
        foot();
        dr.classList.remove('is-bis');
        if (on) { box.hidden = true; box.innerHTML = ''; return; }
        b.setAttribute('aria-checked', 'true');
        var fm = cv.querySelector('[data-rbg-msg]'); if (fm) msg(fm, '');
        dr.classList.add('is-bis');
        var size = b.getAttribute('data-l') || '', vid = b.getAttribute('data-v');
        var sent = null; try { sent = sessionStorage.getItem('rb_bis_' + vid); } catch (e) {}
        if (sent || !bisKey) { box.innerHTML = '<p class="rbl-bis__t">' + esc((sent ? BT.done : BT.t).replace('{size}', size)) + '</p>'; box.hidden = false; return; }
        box.innerHTML = '<form class="rbl-bis__f" novalidate><p class="rbl-bis__t">' + esc(BT.t.replace('{size}', size)) + '</p>' +
          '<input type="email" name="email" autocomplete="email" placeholder="' + esc(BT.email) + '" value="' + esc(savedEmail()) + '" aria-label="' + esc(BT.email) + '">' +
          '<button type="submit" class="rbg-add rbl-bis__go">' + esc(BT.go) + '</button><p class="rbl-bis__err" role="alert"></p></form>';
        box.hidden = false;
        var form = box.querySelector('form');
        setTimeout(function () { try { form.email.focus({ preventScroll: true }); } catch (e) {} }, 40);
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var email = form.email.value.trim(), err = form.querySelector('.rbl-bis__err'), go2 = form.querySelector('.rbl-bis__go');
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = BT.errEmail; form.email.focus(); return; }
          err.textContent = ''; go2.disabled = true; go2.setAttribute('aria-busy', 'true');
          fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(bisKey), {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2024-10-15' },
            body: JSON.stringify({ data: { type: 'back-in-stock-subscription',
              attributes: { profile: { data: { type: 'profile', attributes: { email: email } } }, channels: ['EMAIL'] },
              relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + vid } } } } })
          }).then(function (r) {
            if (!r.ok) throw new Error(r.status);
            try { localStorage.setItem('rb_bis_email', email); sessionStorage.setItem('rb_bis_' + vid, email); } catch (x) {}
            try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'back_in_stock_signup', variant_id: String(vid), size: size, rb_source: 'look-drawer' }); } catch (x) {}
            box.innerHTML = '<p class="rbl-bis__t rbl-bis__t--ok">' + esc(BT.done.replace('{size}', size)) + '</p>';
          }).catch(function () { err.textContent = BT.errSend; go2.disabled = false; go2.removeAttribute('aria-busy'); });
        });
      };

      var mark = function (p, on) {
        var line = sec.querySelector('[data-rbl-line="' + p.getAttribute('data-rbl-pc') + '"]'); if (!line) return;
        var ok = line.querySelector('[data-rbl-ok]'), sel = line.querySelector('.rbl-sel'), z = sizeOf(p), col = colOf(p);
        if (on) { var tt = line.querySelector('[data-rbl-okt]'); if (tt) tt.textContent = '✓ ' + T.added + (col ? ' · ' + col : '') + (z ? ' · ' + T.sizew + ' ' + z : ''); }
        if (ok) ok.hidden = !on;
        if (sel) sel.hidden = !!on;
      };
      sec.addEventListener('click', function (e) {
        var t = e.target;
        var pk = t.closest('[data-rbl-pick]');
        if (pk) {
          // a link (Media and text button) keeps ctrl/cmd-click for the product page; a plain click opens the drawer
          if (pk.tagName === 'A') { if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return; e.preventDefault(); }
          var key = pk.getAttribute('data-rbl-pick'); openL('one', +key.split(':')[0], key); return;
        }
        var lb = t.closest('[data-rbl-look]');
        if (lb) { openL('look', +lb.getAttribute('data-rbl-look')); return; }
        var cur5 = t.closest('[data-rbl-cur]');
        if (cur5) { openL('look', cur); return; }
        var psz = t.closest('[data-rbl-psz]');
        if (psz && dr.contains(psz)) {
          var pp = psz.closest('.rbl-pc');
          pcs.forEach(function (q) { if (q !== pp) { q.classList.remove('is-sz'); q.querySelectorAll('[data-rbl-psz]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); } });
          // Carl 21 Oct: a one-size piece (scarf) has nothing to choose: Add to bag adds it at once
          if (!cvOf(pp).querySelector('.rbg-sz__b')) { var a1 = cvOf(pp).querySelector('[data-rbl-padd]'); if (a1) { a1.classList.remove('is-off'); a1.click(); } return; }
          pp.classList.add('is-sz'); psz.setAttribute('aria-expanded', 'true'); pLab(pp);
          var f1 = cvOf(pp).querySelector('.rbg-sz__b:not([disabled]):not([data-so])'); if (f1) try { f1.focus({ preventScroll: true }); } catch (x) {}
          return;
        }
        var pszx = t.closest('[data-rbl-pszx]');
        if (pszx && dr.contains(pszx)) {
          var px = pszx.closest('.rbl-pc'); px.classList.remove('is-sz');
          var ob = px.querySelector('[data-rbl-psz]'); if (ob) { ob.setAttribute('aria-expanded', 'false'); try { ob.focus({ preventScroll: true }); } catch (x) {} }
          return;
        }
        var padd = t.closest('[data-rbl-padd]');
        if (padd && dr.contains(padd)) {
          if (padd.getAttribute('aria-busy') === 'true') return;
          var pa = padd.closest('.rbl-pc'), it2 = pick(cvOf(pa)); if (!it2) return;
          var colN = (cvOf(pa).getAttribute('data-rbl-col') || '').trim();
          mark(pa, true);
          post([it2], padd, it2.size, function (err) { mark(pa, false); msg(cvOf(pa).querySelector('[data-rbg-msg]'), err); }, true, function () {
            pa.classList.remove('is-sz'); pa.classList.add('is-added');
            var okE = pa.querySelector('[data-rbl-pok]');
            if (okE) { okE.innerHTML = TICK + '<span>' + T.added + (colN ? ' · ' + colN : '') + (it2.size ? ' · ' + T.sizew + ' ' + it2.size : '') + '</span>'; okE.hidden = false; }
          });
          track('add', sec);
          return;
        }
        var szb = t.closest('.rbg-sz__b');
        if (szb && dr.contains(t)) {
          var pz = szb.closest('.rbl-pc');
          if (pz) setTimeout(function () {
            pLab(pz);
            // Carl 21 Oct: in the whole look a size in stock is added as soon as it is tapped (no second button)
            if (mode === 'look' && pz.classList.contains('is-sz') && !szb.hasAttribute('data-so') && !szb.disabled && chosen(pz)) {
              var a2 = pz.querySelector('.rbl-cv:not([hidden]) [data-rbl-padd]'); if (a2 && a2.getAttribute('aria-busy') !== 'true') { szb.classList.add('is-adding'); a2.click(); setTimeout(function () { szb.classList.remove('is-adding'); }, 1200); }
            }
          }, 0);
          // a size in stock: any Notify me form of that piece closes
          var cv = szb.closest('[data-rbg-row]');
          if (cv && !szb.hasAttribute('data-so')) { var bx = cv.querySelector('[data-rbl-bis]'); if (bx) { bx.hidden = true; bx.innerHTML = ''; } dr.classList.remove('is-bis'); }
          foot(); return;
        }
        var to = t.closest('[data-rbl-to]');
        if (to && dr.contains(to)) { swapCol(to.closest('.rbl-pc'), to.getAttribute('data-rbl-to')); return; }
        if (!t.closest('[data-rbl-go]') || go.getAttribute('aria-busy') === 'true') return;
        var list = shown(), items = [], used = [];
        if (mode === 'one') {
          var it = list[0] ? pick(cvOf(list[0])) : null; if (!it) return;
          items.push(it); used.push(list[0]);
        } else {
          list.forEach(function (p) { var f = chosen(p); if (f) { items.push({ id: Number(f.value), quantity: 1, size: sizeOf(p) }); used.push(p); } });
          if (!items.length) {
            msg(dMsg, T.select);
            list.forEach(function (p) { var c = cvOf(p); c.classList.remove('is-warn'); void c.offsetWidth; c.classList.add('is-warn'); });
            return;
          }
        }
        msg(dMsg, '');
        used.forEach(function (p) { mark(p, true); });
        post(items, go, mode === 'one' ? items[0].size : '', function (err) {
          used.forEach(function (p) { mark(p, false); });
          // the drawer closes 260 ms after the tap; show the message in it once that has happened
          setTimeout(function () { if (!dr.classList.contains('is-open')) openL(mode, lk, lkey); msg(dMsg, err); }, 320);
        });
        track(mode === 'one' ? 'add' : 'add_look', sec);
      });
    }

    // carousel (S12): arrows move one picture; "1–4 / 8" follows the scroll
    var car = sec.querySelector('[data-rbg-car]');
    var carNum = sec.querySelector('[data-rbg-carnum]');
    function carStep(d) {
      if (!car || !cards[0]) return;
      var step = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(car).columnGap || 0);
      car.scrollBy({ left: d * step, behavior: reduce.matches ? 'auto' : 'smooth' });
    }
    function carCount() {
      if (!car || !carNum || !cards[0]) return;
      var w = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(car).columnGap || 0);
      var first = Math.round(car.scrollLeft / w) + 1;
      var shown = Math.max(1, Math.floor((car.clientWidth + 2) / w));
      var last = Math.min(cards.length, first + shown - 1);
      carNum.textContent = (shown > 1 ? first + '–' + last : first) + ' / ' + cards.length;
      var pv = sec.querySelector('[data-rbg-cprev]'), nx = sec.querySelector('[data-rbg-cnext]');
      if (pv) pv.disabled = car.scrollLeft < 4;
      if (nx) nx.disabled = car.scrollLeft > car.scrollWidth - car.clientWidth - 4;
    }
    if (car) { car.addEventListener('scroll', carCount, { passive: true }); window.addEventListener('resize', carCount); carCount(); }
    sec.addEventListener('rbg:go', function (e) { show(e.detail); });
    show(0, true);
  }

  function scan() { document.querySelectorAll('[data-rbg]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-rbg]')); });
  document.addEventListener('shopify:block:select', function (e) {
    var sec = e.target.closest && e.target.closest('[data-rbg]');
    var i = e.target.getAttribute && e.target.getAttribute('data-rbg-slide');
    if (sec && i !== null) sec.dispatchEvent(new CustomEvent('rbg:go', { detail: +i }));
  });
  window.RbGallery = { scan: scan };
})();

/* R&B · Collection grid (FW26 S8): filters on the page, calm fade; phones show the first few with "View all" */
(function () {
  if (window.RbCollGrid) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var phone = window.matchMedia('(max-width: 989px)');
  function init(sec) {
    if (!sec || sec.rbcg) return; sec.rbcg = true;
    var grid = sec.querySelector('[data-rbk-cg-grid]');
    var items = [].slice.call(sec.querySelectorAll('.rbk-cg__it'));
    var more = sec.querySelector('[data-rbk-cg-more]');
    var moreN = sec.querySelector('[data-rbk-cg-n]');
    var cap = +sec.getAttribute('data-mobile') || 6;
    var group = '', open = false;
    function apply() {
      var shown = 0, match = 0;
      items.forEach(function (it) {
        var ok = !group || it.getAttribute('data-g') === group;
        if (ok) match++;
        var vis = ok && (open || !phone.matches || match <= cap);
        it.hidden = !vis;
        if (vis) shown++;
      });
      if (more) { more.hidden = open || !phone.matches || match <= cap; if (moreN) moreN.textContent = match; }
    }
    sec.addEventListener('click', function (e) {
      var f = e.target.closest('[data-rbk-cg-f]');
      if (f) {
        var g = f.getAttribute('data-rbk-cg-f');
        if (g === group) return;
        sec.querySelectorAll('[data-rbk-cg-f]').forEach(function (b) { b.setAttribute('aria-pressed', b === f ? 'true' : 'false'); });
        group = g; open = false;
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'rb_filter', rb_filter_section: 'collection-grid', rb_filter_value: g || 'all' }); } catch (err) {}
        if (reduce.matches) { apply(); return; }
        grid.classList.add('is-out');
        setTimeout(function () { apply(); grid.classList.remove('is-out'); }, 200);
        return;
      }
      if (e.target.closest('[data-rbk-cg-more]')) { open = true; apply(); }
    });
    if (phone.addEventListener) phone.addEventListener('change', apply);
    apply();
  }
  function scan() { document.querySelectorAll('[data-rbk-cg]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-rbk-cg]')); });
  window.RbCollGrid = { scan: scan };
})();
